import React from 'react'
import Navbar from '../components/common/Navbar'
import { Link } from 'react-router-dom'

export default function TripPaymentCompletePage({ transactionId }) {
    return (
        <div>
            <Navbar />
            <section className="thankyou-main-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 offset-lg-2">
                            <img src="/images/icons/payment-success.svg" alt="Thank You" className="img-fluid" />
                            <h1>Payment Successfull!</h1>
                            {/* <p className="tip-id">Trip ID: #{params.id}</p> */}
                            <p className="tip-id">Transaction ID: #{transactionId}</p>
                            <p className="text-para">Thank you for the payment. We hope that you will provide us more chances to serve in the future. <br /><br /> Feel free to contact us for any kind of query!</p>
                            <Link to="/trip/add" className="request-another-btn">Request for Another Trip</Link>
                            <Link to="/" className="goto-dashboard">Go to your Dashboard</Link>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
